import React from 'react'

const ScrollContext = React.createContext('scroll')

export default ScrollContext;
